import { styled } from 'src/styles/styled-components'

export default styled.p`
  font-size: 1.8rem;
  font-weight: ${ p => p.theme.fontWeight.primary.Light };
  letter-spacing: 0.01em;
  line-height: 1.55;
`
